var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/typography.scss';
import { SvgIconBase } from '@front/sharedcomponents/SvgIcon/createSvgIcon';
import AcceptIcon from '@styles/webdesktop/Icons/accept.svg';
import AccountIcon from '@styles/webdesktop/Icons/account.svg';
import AccountLookupIcon from '@styles/webdesktop/Icons/accountLookup.svg';
import AccountOperation from '@styles/webdesktop/Icons/accountOperation.svg';
import AddIcon from '@styles/webdesktop/Icons/add.svg';
import AlertsIcon from '@styles/webdesktop/Icons/alerts.svg';
import ArrowDownIcon from '@styles/webdesktop/Icons/arrowDown.svg';
import ArrowLeftIcon from '@styles/webdesktop/Icons/arrowLeft.svg';
import ArrowRightIcon from '@styles/webdesktop/Icons/arrowRight.svg';
import ArrowUpIcon from '@styles/webdesktop/Icons/arrowUp.svg';
import BetaIcon from '@styles/webdesktop/Icons/beta.svg';
import Calculator from '@styles/webdesktop/Icons/calculator.svg';
import Cancel from '@styles/webdesktop/Icons/cancel.svg';
import ChartDrawingStyleAreaIcon from '@styles/webdesktop/Icons/chartDrawingStyleArea.svg';
import ChartDrawingStyleBarIcon from '@styles/webdesktop/Icons/chartDrawingStyleBar.svg';
import ChartDrawingStyleCandlesIcon from '@styles/webdesktop/Icons/chartDrawingStyleCandles.svg';
import ChartDrawingStyleDotsIcon from '@styles/webdesktop/Icons/chartDrawingStyleDots.svg';
import ChartDrawingStyleHistogramIcon from '@styles/webdesktop/Icons/chartDrawingStyleHistogram.svg';
import ChartDrawingStyleLineIcon from '@styles/webdesktop/Icons/chartDrawingStyleLine.svg';
import ChartIcon from '@styles/webdesktop/Icons/chartIcon.svg';
import CheckboxIcon from '@styles/webdesktop/Icons/checkbox.svg';
import CloseIcon from '@styles/webdesktop/Icons/closeCrossBtn.svg';
import ClosePositionByMktIcon from '@styles/webdesktop/Icons/closePositionByMkt.svg';
import CloseViaOEIcon from '@styles/webdesktop/Icons/closeViaOE.svg';
import CollapseAllIcon from '@styles/webdesktop/Icons/collapseAllIcon.svg';
import CopyIcon from '@styles/webdesktop/Icons/copy.svg';
import DateIcon from '@styles/webdesktop/Icons/dateIcon.svg';
import DelayedDataIcon from '@styles/webdesktop/Icons/delayedData.svg';
import EditableListIcon from '@styles/webdesktop/Icons/editableList.svg';
import EditIcon from '@styles/webdesktop/Icons/editIcon.svg';
import ExpandExchangesIcon from '@styles/webdesktop/Icons/expandExchangesIcon.svg';
import ExpandTypesIcon from '@styles/webdesktop/Icons/expandTypesIcon.svg';
import ExportIcon from '@styles/webdesktop/Icons/export.svg';
import GainersLosersIcon from '@styles/webdesktop/Icons/gainersLosers.svg';
import GoToBtnIcon from '@styles/webdesktop/Icons/goToBtn.svg';
import GridIcon from '@styles/webdesktop/Icons/grid.svg';
import HelpIcon from '@styles/webdesktop/Icons/help.svg';
import HighLowIcon from '@styles/webdesktop/Icons/highLowList.svg';
import IdeasIcon from '@styles/webdesktop/Icons/ideas.svg';
import IndicatorIcon from '@styles/webdesktop/Icons/indicatorButton.svg';
import InfoTool from '@styles/webdesktop/Icons/info.svg';
import InstrumentLookupIcon from '@styles/webdesktop/Icons/instrumentLookup.svg';
import InvisibleDataIcon from '@styles/webdesktop/Icons/invisibleData.svg';
import LinkedAccountsIcon from '@styles/webdesktop/Icons/linkedAccounts.svg';
import LogoutIcon from '@styles/webdesktop/Icons/logout.svg';
import MenuErrorIcon from '@styles/webdesktop/Icons/menuError.svg';
import MinusIcon from '@styles/webdesktop/Icons/minus.svg';
import MouseTradeIcon from '@styles/webdesktop/Icons/mouseTradeButton.svg';
import MoveSeparatorVerticalIcon from '@styles/webdesktop/Icons/moveSeparatorVertical.svg';
import NewsIcon from '@styles/webdesktop/Icons/newsIcon.svg';
import NotificationsIcon from '@styles/webdesktop/Icons/notifications.svg';
import ObjectManagerIcon from '@styles/webdesktop/Icons/objectManagerButton.svg';
import OrderEntryIcon from '@styles/webdesktop/Icons/orderEntry.svg';
import OrderModifyArrow from '@styles/webdesktop/Icons/orderModifyArrow.svg';
import OverlayIcon from '@styles/webdesktop/Icons/overlayButton.svg';
import PlayIcon from '@styles/webdesktop/Icons/playIcon.svg';
import PositionSizingIcon from '@styles/webdesktop/Icons/positionSizing.svg';
import QRSidebarIcon from '@styles/webdesktop/Icons/qrSidebar.svg';
import QuestionIcon from '@styles/webdesktop/Icons/question.svg';
import Refresh from '@styles/webdesktop/Icons/refresh.svg';
import SearchIcon from '@styles/webdesktop/Icons/search.svg';
import SettingsIcon from '@styles/webdesktop/Icons/settings.svg';
import SnapshotIcon from '@styles/webdesktop/Icons/snapshot.svg';
import SortDownIcon from '@styles/webdesktop/Icons/sortDown.svg';
import SortUpIcon from '@styles/webdesktop/Icons/sortUp.svg';
import StatementIcon from '@styles/webdesktop/Icons/statement.svg';
import StopIcon from '@styles/webdesktop/Icons/stopIcon.svg';
import TabStripItemLockedIcon from '@styles/webdesktop/Icons/tabStripItemLocked.svg';
import TimeClockIcon from '@styles/webdesktop/Icons/timeClock.svg';
import ToolsIcon from '@styles/webdesktop/Icons/toolsButton.svg';
import TrailingStopIcon from '@styles/webdesktop/Icons/trailingStop.svg';
import UpdateNotificationArrowIcon from '@styles/webdesktop/Icons/updateNotificationArrow.svg';
import UserGroupIcon from '@styles/webdesktop/Icons/userGroup.svg';
import VideoWidgetIcon from '@styles/webdesktop/Icons/videoWidget.svg';
import VideoWidgetLiveIcon from '@styles/webdesktop/Icons/videoWidgetLive.svg';
import ViewGroupIcon from '@styles/webdesktop/Icons/viewGroup.svg';
import ViewMoreHorizontalIcon from '@styles/webdesktop/Icons/viewMoreHorizontal.svg';
import VisibleDataIcon from '@styles/webdesktop/Icons/visibleData.svg';
import { SvgIconType } from './SvgIconType';
const ICONS_MAP = {
    [SvgIconType.Add]: _jsx(AddIcon, {}),
    [SvgIconType.VisibleData]: _jsx(VisibleDataIcon, {}),
    [SvgIconType.InvisibleData]: _jsx(InvisibleDataIcon, {}),
    [SvgIconType.Copy]: _jsx(CopyIcon, {}),
    [SvgIconType.Overlay]: _jsx(OverlayIcon, {}),
    [SvgIconType.Indicator]: _jsx(IndicatorIcon, {}),
    [SvgIconType.Tools]: _jsx(ToolsIcon, {}),
    [SvgIconType.OrderEntry]: _jsx(OrderEntryIcon, {}),
    [SvgIconType.MouseTrade]: _jsx(MouseTradeIcon, {}),
    [SvgIconType.ObjectManager]: _jsx(ObjectManagerIcon, {}),
    [SvgIconType.Checkbox]: _jsx(CheckboxIcon, {}),
    [SvgIconType.ArrowDown]: _jsx(ArrowDownIcon, {}),
    [SvgIconType.ArrowUp]: _jsx(ArrowUpIcon, {}),
    [SvgIconType.ArrowRight]: _jsx(ArrowRightIcon, {}),
    [SvgIconType.ArrowLeft]: _jsx(ArrowLeftIcon, {}),
    [SvgIconType.Edit]: _jsx(EditIcon, {}),
    [SvgIconType.Close]: _jsx(CloseIcon, {}),
    [SvgIconType.MenuError]: _jsx(MenuErrorIcon, {}),
    [SvgIconType.UpdateNotificationArrow]: _jsx(UpdateNotificationArrowIcon, {}),
    [SvgIconType.Search]: _jsx(SearchIcon, {}),
    [SvgIconType.Beta]: _jsx(BetaIcon, {}),
    [SvgIconType.InstrumentLookup]: _jsx(InstrumentLookupIcon, {}),
    [SvgIconType.PositionSizing]: _jsx(PositionSizingIcon, {}),
    [SvgIconType.TrailingStop]: _jsx(TrailingStopIcon, {}),
    [SvgIconType.Date]: _jsx(DateIcon, {}),
    [SvgIconType.TimeClock]: _jsx(TimeClockIcon, {}),
    [SvgIconType.CollapseAll]: _jsx(CollapseAllIcon, {}),
    [SvgIconType.ExpandExchanges]: _jsx(ExpandExchangesIcon, {}),
    [SvgIconType.ExpandTypes]: _jsx(ExpandTypesIcon, {}),
    [SvgIconType.SortUp]: _jsx(SortUpIcon, {}),
    [SvgIconType.SortDown]: _jsx(SortDownIcon, {}),
    [SvgIconType.Minus]: _jsx(MinusIcon, {}),
    [SvgIconType.Play]: _jsx(PlayIcon, {}),
    [SvgIconType.Stop]: _jsx(StopIcon, {}),
    [SvgIconType.Help]: _jsx(HelpIcon, {}),
    [SvgIconType.Ideas]: _jsx(IdeasIcon, {}),
    [SvgIconType.Alerts]: _jsx(AlertsIcon, {}),
    [SvgIconType.Notifications]: _jsx(NotificationsIcon, {}),
    [SvgIconType.VideoWidget]: _jsx(VideoWidgetIcon, {}),
    [SvgIconType.VideoWidgetLive]: _jsx(VideoWidgetLiveIcon, {}),
    [SvgIconType.Settings]: _jsx(SettingsIcon, {}),
    [SvgIconType.Logout]: _jsx(LogoutIcon, {}),
    [SvgIconType.QRSidebar]: _jsx(QRSidebarIcon, {}),
    [SvgIconType.ViewMoreHorizontal]: _jsx(ViewMoreHorizontalIcon, {}),
    [SvgIconType.Snapshot]: _jsx(SnapshotIcon, {}),
    [SvgIconType.DelayedData]: _jsx(DelayedDataIcon, {}),
    [SvgIconType.GoToBtn]: _jsx(GoToBtnIcon, {}),
    [SvgIconType.ChartDrawingStyleCandles]: _jsx(ChartDrawingStyleCandlesIcon, {}),
    [SvgIconType.EditableList]: _jsx(EditableListIcon, {}),
    [SvgIconType.ChartDrawingStyleLine]: _jsx(ChartDrawingStyleLineIcon, {}),
    [SvgIconType.ChartDrawingStyleBar]: _jsx(ChartDrawingStyleBarIcon, {}),
    [SvgIconType.ChartDrawingStyleDots]: _jsx(ChartDrawingStyleDotsIcon, {}),
    [SvgIconType.ChartDrawingStyleHistogram]: _jsx(ChartDrawingStyleHistogramIcon, {}),
    [SvgIconType.ChartDrawingStyleArea]: _jsx(ChartDrawingStyleAreaIcon, {}),
    [SvgIconType.MoveSeparatorVertical]: _jsx(MoveSeparatorVerticalIcon, {}),
    [SvgIconType.ClosePositionByMkt]: _jsx(ClosePositionByMktIcon, {}),
    [SvgIconType.CloseViaOE]: _jsx(CloseViaOEIcon, {}),
    [SvgIconType.OrderModifyArrow]: _jsx(OrderModifyArrow, {}),
    [SvgIconType.InfoTool]: _jsx(InfoTool, {}),
    [SvgIconType.AccountOperation]: _jsx(AccountOperation, {}),
    [SvgIconType.Cancel]: _jsx(Cancel, {}),
    [SvgIconType.TabStripItemLocked]: _jsx(TabStripItemLockedIcon, {}),
    [SvgIconType.ViewGroup]: _jsx(ViewGroupIcon, {}),
    [SvgIconType.Export]: _jsx(ExportIcon, {}),
    [SvgIconType.Refresh]: _jsx(Refresh, {}),
    [SvgIconType.Calculator]: _jsx(Calculator, {}),
    [SvgIconType.Chart]: _jsx(ChartIcon, {}),
    [SvgIconType.News]: _jsx(NewsIcon, {}),
    [SvgIconType.GainersLosers]: _jsx(GainersLosersIcon, {}),
    [SvgIconType.HighLow]: _jsx(HighLowIcon, {}),
    [SvgIconType.Accept]: _jsx(AcceptIcon, {}),
    [SvgIconType.Question]: _jsx(QuestionIcon, {}),
    [SvgIconType.AccountLookup]: _jsx(AccountLookupIcon, {}),
    [SvgIconType.Grid]: _jsx(GridIcon, {}),
    [SvgIconType.UserGroup]: _jsx(UserGroupIcon, {}),
    [SvgIconType.LinkedAccounts]: _jsx(LinkedAccountsIcon, {}),
    [SvgIconType.Account]: _jsx(AccountIcon, {}),
    [SvgIconType.Statement]: _jsx(StatementIcon, {})
};
export const SvgIcon = (_a) => {
    var { icon } = _a, rest = __rest(_a, ["icon"]);
    return _jsx(SvgIconBase, Object.assign({ icon: ICONS_MAP[icon] }, rest));
};
